/**
 * Toggle mock data for /pedidos table.
 * Set to `true` to bypass the API and render the mocked orders below.
 * Set to `false` to use real Redux/API data.
 */
export const USE_MOCK_ORDERS = false;

const mockOrderItems = (products) => JSON.stringify(products);

const mockLicenseCodes = (entries = []) => JSON.stringify(entries);

const sampleLicenses = [
  {
    product: { name: 'Licença Software Pro' },
    licenses: [
      {
        name: 'Licença anual',
        codes: [{ serial_number: 'LIC-MOCK-001-AAAA' }, { serial_number: 'LIC-MOCK-001-BBBB' }],
      },
    ],
  },
];

const MOCK_ORDERS_RAW = [
  {
    id: 1001,
    order_id: 'ORD-1001',
    order_number: '10482',
    order_link: 'https://example.com/orders/10482',
    created_at: '2026-10-26T14:32:00.000Z',
    customer_name: 'Ana Clara Souza',
    customer_email: 'ana.souza@email.com',
    email: 'ana.souza@email.com',
    is_canceled: 0,
    is_email_send: 1,
    order_items: mockOrderItems([
      {
        product: {
          name: 'Pack Presets Lightroom',
          image_url: 'https://placehold.co/64x64/png?text=P1',
          url: 'https://example.com/products/presets',
        },
        quantity: 1,
      },
      {
        product: {
          name: 'Guia de Fotografia PDF',
          image_url: 'https://placehold.co/64x64/png?text=P2',
          url: 'https://example.com/products/guia',
        },
        quantity: 1,
      },
    ]),
  },
  {
    id: 1002,
    order_id: 'ORD-1002',
    order_number: '10483',
    order_link: 'https://example.com/orders/10483',
    created_at: '2026-10-25T19:10:00.000Z',
    customer_name: 'Bruno Martins',
    customer_email: 'bruno.martins@email.com',
    email: 'bruno.martins@email.com',
    is_canceled: 0,
    is_email_send: 0,
    order_items: mockOrderItems([
      {
        product: {
          name: 'Curso de Edição Online',
          image_url: 'https://placehold.co/64x64/png?text=C1',
          url: 'https://example.com/products/curso',
        },
        quantity: 1,
      },
    ]),
  },
  {
    id: 1003,
    order_id: 'ORD-1003',
    order_number: '10484',
    order_link: 'https://example.com/orders/10484',
    created_at: '2026-10-24T11:05:00.000Z',
    customer_name: 'Camila Ferreira',
    customer_email: 'camila.ferreira@email.com',
    email: 'camila.ferreira@email.com',
    is_canceled: 1,
    is_email_send: 0,
    order_items: mockOrderItems([
      {
        product: {
          name: 'Licença Software Pro',
          image_url: 'https://placehold.co/64x64/png?text=L1',
          url: 'https://example.com/products/licenca',
        },
        quantity: 1,
      },
      {
        product: {
          name: 'Suporte Premium 30 dias',
          image_url: 'https://placehold.co/64x64/png?text=L2',
          url: 'https://example.com/products/suporte',
        },
        quantity: 1,
      },
      {
        product: {
          name: 'Templates PowerPoint',
          image_url: 'https://placehold.co/64x64/png?text=L3',
          url: 'https://example.com/products/templates',
        },
        quantity: 2,
      },
    ]),
    order_items_codes: mockLicenseCodes(sampleLicenses),
  },
  {
    id: 1004,
    order_id: 'ORD-1004',
    order_number: null,
    order_link: 'https://example.com/orders/ORD-1004',
    created_at: '2026-10-23T08:45:00.000Z',
    customer_name: 'Diego Alves',
    customer_email: 'diego.alves@email.com',
    email: 'diego.alves@email.com',
    is_canceled: 0,
    is_email_send: 1,
    order_items: mockOrderItems([
      {
        product: {
          name: 'E-book Marketing Digital',
          image_url: 'https://placehold.co/64x64/png?text=E1',
          url: 'https://example.com/products/ebook',
        },
        quantity: 1,
      },
    ]),
  },
  {
    id: 1005,
    order_id: 'ORD-1005',
    order_number: '10486',
    order_link: 'https://example.com/orders/10486',
    created_at: '2026-10-22T16:20:00.000Z',
    customer_name: 'Elena Ribeiro',
    customer_email: 'elena.ribeiro@email.com',
    email: 'elena.ribeiro@email.com',
    is_canceled: 0,
    is_email_send: 1,
    order_items: mockOrderItems([
      {
        product: {
          name: 'Pacote Office · Word + PowerPoint',
          image_url: 'https://placehold.co/64x64/png?text=O1',
          url: 'https://example.com/products/office',
        },
        quantity: 1,
      },
      {
        product: {
          name: 'Aulas online',
          image_url: 'https://placehold.co/64x64/png?text=O2',
          url: 'https://example.com/products/aulas',
        },
        quantity: 1,
      },
      {
        product: {
          name: 'Presets essenciais.zip',
          image_url: 'https://placehold.co/64x64/png?text=O3',
          url: 'https://example.com/products/presets-zip',
        },
        quantity: 1,
      },
      {
        product: {
          name: 'Guia de fotografia.pdf',
          image_url: 'https://placehold.co/64x64/png?text=O4',
          url: 'https://example.com/products/guia-foto',
        },
        quantity: 1,
      },
    ]),
  },
  {
    id: 1006,
    order_id: 'ORD-1006',
    order_number: '10487',
    order_link: 'https://example.com/orders/10487',
    created_at: '2026-10-21T09:00:00.000Z',
    customer_name: 'Felipe Costa',
    customer_email: 'felipe.costa@email.com',
    email: 'felipe.costa@email.com',
    is_canceled: 1,
    is_email_send: 1,
    order_items: mockOrderItems([]),
  },
  {
    id: 1007,
    order_id: 'ORD-1007',
    order_number: '10488',
    order_link: 'https://example.com/orders/10488',
    created_at: '2026-10-20T21:15:00.000Z',
    customer_name: 'Gabriela Nunes',
    customer_email: 'gabriela.nunes@email.com',
    email: 'gabriela.nunes@email.com',
    is_canceled: 0,
    is_email_send: 0,
    order_items: mockOrderItems([
      {
        product: {
          name: 'Kit Ícones SVG',
          image_url: 'https://placehold.co/64x64/png?text=I1',
          url: 'https://example.com/products/icones',
        },
        quantity: 1,
      },
      {
        product: {
          name: 'Fontes Premium',
          image_url: 'https://placehold.co/64x64/png?text=I2',
          url: 'https://example.com/products/fontes',
        },
        quantity: 1,
      },
    ]),
  },
  {
    id: 1008,
    order_id: 'ORD-1008',
    order_number: '10489',
    order_link: 'https://example.com/orders/10489',
    created_at: '2026-10-19T13:40:00.000Z',
    customer_name: 'Henrique Lima',
    customer_email: 'henrique.lima@email.com',
    email: 'henrique.lima@email.com',
    is_canceled: 0,
    is_email_send: 1,
    order_items: mockOrderItems([
      {
        product: {
          name: 'Vídeo Masterclass',
          image_url: 'https://placehold.co/64x64/png?text=V1',
          url: 'https://example.com/products/masterclass',
        },
        quantity: 1,
      },
    ]),
  },
];

export const MOCK_ORDERS = MOCK_ORDERS_RAW.map((order) => ({
  ...order,
  order_items_codes: order.order_items_codes ?? mockLicenseCodes([]),
}));

export const MOCK_ORDERS_META = {
  current_page: 1,
  last_page: 1,
  per_page: MOCK_ORDERS.length,
  total: MOCK_ORDERS.length,
  from: 1,
  to: MOCK_ORDERS.length,
};

/** Shape compatible with `reducerSales` / TableOrders (`orders.data.data` + `orders.data.meta`). */
export const MOCK_ORDERS_STATE = {
  loading: false,
  error: false,
  data: {
    data: MOCK_ORDERS,
    meta: MOCK_ORDERS_META,
  },
};
